import { routePaths } from '../../routePaths';
import { translate } from '../../utils';
import { RouteType } from '../../types';
import { BackofficePermission } from '../../generated/graphql';
import { CategoriesIcon } from '../../ui-kit';
import CategoryListView from './CategoryListView';
import CategoryCreateView from './CategoryCreateView';
import CategoryUpdateView from './CategoryUpdateView';

const CategoriesRoute: RouteType = {
    exact: true,
    path: routePaths.categories,
    title: translate('Categories'),
    icon: CategoriesIcon,
    component: CategoryListView,
    permissions: {
        backoffice: [BackofficePermission.HasAccess]
    },
    childrenRoutes: [
        {
            exact: true,
            title: translate('Create category'),
            path: routePaths.categoriesCreate,
            component: CategoryCreateView,
        },
        {
            exact: true,
            title: translate('Update Category'),
            path: routePaths.categoriesUpdate,
            component: CategoryUpdateView,
        }
    ],
};

export default CategoriesRoute;
